"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const line1 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const line2 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const line3 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const rightPara = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const bottomPara = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const baseReveal = "transition-all duration-500 ease-out will-change-transform";
  const hidden = "opacity-0 translate-y-4";
  const shown = "opacity-100 translate-y-0";
  return;
}